import { HttpErrorResponse, HttpStatusCode } from '@angular/common/http';

export const isUnsupportedMediaType = (
  response: HttpErrorResponse,
): boolean => {
  return response.status === HttpStatusCode.UnsupportedMediaType;
};
